export class LiveDataTotalModel {

  applicationId: number | undefined;
  taskCount: number | undefined;
  messageCount: number | undefined;

  constructor() {
  }
}
